import { walletConstants } from '../_constants';

export function wallet(state = {}, action) {
  switch (action.type) {
    case walletConstants.GETUSERWALLET_REQUEST:
      return {
        loading : true
      };
    case walletConstants.GETUSERWALLET_SUCCESS:
      return { 
        userwallet : action.userwallet , 
        loading : false
      };
    case walletConstants.GETUSERWALLET_FAILURE:
      return {
        loading : false
      };
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/wallet.reducer.js